// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__hN7cV","pagination":"styles_pagination__lKNwk"};